// extracted by mini-css-extract-plugin
export default {"rowName":"LinkComponent_rowName__v9onQ","underline":"LinkComponent_underline__4yNqW","bold":"LinkComponent_bold__5OX92"};